import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5.516 13.155l7.191-9.16c.517-.659 1.573-.23 1.484.603l-.525 4.905h4.17a.833.833 0 01.655 1.348l-7.199 9.169c-.517.658-1.573.23-1.484-.603l.525-4.915H6.172a.833.833 0 01-.656-1.347z"
        fill={props.color ?? "#141416"}
        fillOpacity={0.7}
      />
    </svg>
  );
}

export default SvgComponent;
